import getConfig from '../config';
import { LANG_TO_LOCALE_MAP } from './constants';

export interface Dummy {
  subtype: string;
  industries: string[];
  rating: number;
  desktop: string;
  mobile: string;
}

export interface TemplateImage {
  small: string;
  medium: string;
  large: string;
  placeholder: string;
}

export interface Template {
  subtype: string;
  industries: string[];
  rating: number;
  desktopImage: TemplateImage;
  mobileImage: TemplateImage;
}

interface Dummies {
  [lang: string]: Template[];
}

const { language } = getConfig();
const languages = Object.keys(LANG_TO_LOCALE_MAP);

// This has to be existing in a hard-coded way
// for Webpack to be able to statically analyze
// the code & load the files during compilation.
const getResource = (lang: string, file: string): TemplateImage => {
  // tslint:disable:non-literal-require
  const small = require(`../../dummies/dist/${lang}/images/330_${file}`);
  const medium = require(`../../dummies/dist/${lang}/images/480_${file}`);
  const large = require(`../../dummies/dist/${lang}/images/640_${file}`);
  const placeholder = require(`../../dummies/dist/${lang}/images/placeholder_${file}`);
  // tslint:enable:non-literal-require

  return {
    small,
    medium,
    large,
    placeholder,
  };
};

const getTemplateFromDummy = (lang: string, dummy: Dummy): Template => ({
  subtype: dummy.subtype,
  industries: dummy.industries,
  rating: dummy.rating,
  desktopImage: getResource(lang, dummy.desktop),
  mobileImage: getResource(lang, dummy.mobile),
});

const dummies = languages.reduce((acc: Dummies, lang: string) => {
  // tslint:disable-next-line:non-literal-require
  const dummyList = require(`../../dummies/dist/${lang}/dummies.json`) as Dummy[];
  return {
    ...acc,
    [lang]: dummyList.reduce(
      (innerAcc: Template[], dummy: Dummy) => [
        ...innerAcc,
        getTemplateFromDummy(lang, dummy),
      ],
      []
    ),
  };
}, {});

const sortDummies = (a: Template, b: Template): number => {
  if (a.rating === b.rating) {
    return 0;
  }
  return a.rating < b.rating ? 1 : -1;
};

const templateImages: Template[] = dummies[language].sort(sortDummies);

export const getFilteredTemplateImages = (
  tmplImages: Template[],
  industry?: string
): Template[] => {
  const filtered = tmplImages.filter(
    (tmpl: Template): boolean =>
      industry && tmpl.industries.includes(industry)
  );
  // Filtering only applies in german signup flow
  if (filtered.length && language === 'de') {
    return filtered.sort(sortDummies);
  }
  return tmplImages.slice(0);
};

export const getTemplateImagesBySubtype = (
  tmplImages: Template[],
  subtype: string
): Template =>
  tmplImages.find((tmpl: Template): boolean => tmpl.subtype === subtype);

export default templateImages;
